import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'lg', 'xl', 'sb', 'sb-xl']),
  className: PropTypes.string,
};

const Content = ({ children, className, size }) => {
  const classes = classNames({
    'create-wizard-layout-content': true,
    'is-large': size === 'lg',
    'is-small': size === 'sm',
    'is-xl': size === 'xl',
    'is-shutterbug': size === 'sb',
    'is-shutterbug-xl': size === 'sb-xl',
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Content.propTypes = propTypes;

export default Content;
